import { useEffect, useState } from "react"
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from '@mui/material/Button'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import * as Basic from "../../../Modules/BasicFields"
import DataListModal from "../../DataModals/DataListModal"

const quickdrawVariables = [
    {name:'Output', key:'output', type:'W'},
]

export default function Quickdraw( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    const [ phrases, setPhrases ] = useState(null)

    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const [ showModal, setShowModal ] = useState(false)

    const requiredData = [
        phrases,
        font,
        variables
    ]

    const cfgName = "kingmaker_quickdraw_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setPhrases( cfg.phrases || [])
        setFont( cfg.font || {})
        setVariables( cfg.variables || {})
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.phrases = phrases
        data.font = font 
        data.variables = variables

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ phrases, font, variables ])

    if( requiredData.includes(null) )
    {
        return (<></>)
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.ButtonInput name="Edit phrases" onClick={e => setShowModal(true)}/>
            </SettingsGroup>

            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={quickdrawVariables}
                            reset={reset}
            />
            <DataListModal modalTitle="Edit phrases"
                           showModal={showModal} 
                           setShowModal={setShowModal} 
                           list={phrases}
                           setList={setPhrases}
            />
        </>
    )
}

